// import React from 'react';
import { useState } from 'react';
import Navbar from '../../components/navbar/Navbar';
import Sidebar from '../../components/navbar/Sidebar';
import Footer from '../../components/footer/Footer'; 
import LegacyFitnessAndWellnessProgramsBody from '../../components/internal/LegacyHighSchool/LegacyFitnessAndWellnessPrograms/LegacyFitnessAndWellnessProgramsBody'; // Import FitnessAndWellnessProgramsBody component

function LegacyFitnessAndWellnessPrograms() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <LegacyFitnessAndWellnessProgramsBody />
      <Footer />
    </>
  );
}

export default LegacyFitnessAndWellnessPrograms;